import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "helperMessage", "hasError", "inputProps", "onChange", "value", "id", "type", "required", "infoTooltipContent"];
import { theme } from "@vitality-ds/system";
import { Info } from "lucide-react";
import React from "react";
import Box from "../../Box";
import Stack from "../../Stack";
import Tooltip from "../../Tooltip";
import HelperMessage from "../HelperMessage";
import Fieldset from "./components/Fieldset";
import FormFieldLabel from "./components/FormFieldLabel";
import { getDescribedById, getErrorMessageId, getInputComponent, getLabelledById } from "./logic";
import { IconWrapper } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function FormField(_ref) {
  var label = _ref.label,
    helperMessage = _ref.helperMessage,
    hasError = _ref.hasError,
    inputProps = _ref.inputProps,
    onChange = _ref.onChange,
    value = _ref.value,
    id = _ref.id,
    type = _ref.type,
    required = _ref.required,
    infoTooltipContent = _ref.infoTooltipContent,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var inputComponent = getInputComponent(type);
  var Component = inputComponent.component;
  var ariaDescribedById = getDescribedById(id);
  var ariaErrorId = getErrorMessageId(id);
  var ariaLabelledById = getLabelledById(id);
  return /*#__PURE__*/_jsxs(Fieldset, _extends({}, restProps, {
    children: [/*#__PURE__*/_jsxs(Stack, {
      spacing: "sm",
      direction: "horizontal",
      align: "center",
      children: [/*#__PURE__*/_jsx(Box, {
        maxWidth: infoTooltipContent ? "90%" : "100%",
        children: /*#__PURE__*/_jsx(FormFieldLabel, {
          fieldType: type,
          content: label,
          htmlFor: id,
          id: ariaLabelledById,
          required: required,
          hasError: hasError
        })
      }), infoTooltipContent && /*#__PURE__*/_jsx(Box, {
        maxWidth: "10%",
        minWidth: "16px" // this is the same width as the icon size="sm"
        ,
        minHeight: theme.fontSizes.caption.value,
        children: /*#__PURE__*/_jsx(IconWrapper, {
          children: /*#__PURE__*/_jsx(Tooltip, {
            content: infoTooltipContent,
            children: /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(Info, {
                color: "currentColor",
                size: "0.875rem"
              })
            })
          })
        })
      })]
    }), /*#__PURE__*/_jsx(Component, _extends({
      onChange: onChange,
      value: value,
      id: id,
      "aria-labelledby": ariaLabelledById,
      "aria-describedby": ariaDescribedById,
      "aria-required": required,
      "aria-errormessage": ariaErrorId,
      required: required,
      hasError: hasError
    }, inputProps)), helperMessage && /*#__PURE__*/_jsx(HelperMessage, {
      hasError: hasError,
      id: hasError ? ariaErrorId : ariaDescribedById,
      children: helperMessage
    })]
  }));
}
export default FormField;